import { memo } from 'react';
import { CardData } from '../../../../../types';
import { ArrowButtonHome } from './ArrowButtonHome';

interface PreviewCardProps {
    card: CardData;
    cardIndex: number;
    interactive?: boolean;
    isHighlighted?: boolean;
    isDimmed?: boolean;
    onClick?: (id: string) => void;
    onKeyDown?: (e: React.KeyboardEvent, id: string) => void;
}

export const PreviewCard = memo(({ card, cardIndex, interactive = true, isHighlighted, isDimmed, onClick, onKeyDown }: PreviewCardProps) => {
    const clickableProps = (id: string, label: string) => interactive && onClick && onKeyDown ? {
        onClick: () => onClick(id),
        onKeyDown: (e: React.KeyboardEvent) => onKeyDown(e, id),
        role: "button",
        tabIndex: 0,
        'aria-label': label,
        title: `Click to edit ${label.toLowerCase().replace('edit ', '')}`
    } : {};

    return (
        <div className={`preview-card-item ${isHighlighted ? 'highlighted' : ''} ${isDimmed ? 'dimmed' : ''}`.trim()}>
            <div
                className="preview-card-image-container"
                style={{
                    borderRadius: `${card.imageRadius}px`
                }}
                {...clickableProps(`card-${cardIndex + 1}-image-section`, `Edit image for ${card.title || 'card'}`)}
            >
                {card.image ? (
                    <img
                        src={card.image}
                        alt={card.altText || card.title}
                        style={{
                            objectFit: card.objectFit as any,
                        }}
                    />
                ) : (
                    <div className="preview-placeholder-image">
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path d="M21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19ZM8.5 13.5L11 16.51L14.5 12L19 18H5L8.5 13.5Z" fill="#9CA3AF" />
                        </svg>
                    </div>
                )}
                {card.image && (
                    <div
                        className="image-overlay"
                        style={{
                            opacity: card.overlayOpacity / 100,
                        }}
                    />
                )}
            </div>

            <div className="preview-card-content">
                <h3
                    className="preview-card-title"
                    style={{
                        color: card.titleColor,
                    }}
                    {...clickableProps(`card-${cardIndex + 1}-title`, `Edit title: ${card.title}`)}
                >
                    {card.title || 'CARD TITLE'}
                </h3>
                <p
                    className="preview-card-subtitle"
                    style={{
                        color: card.subtitleColor,
                    }}
                    {...clickableProps(`card-${cardIndex + 1}-subtitle`, `Edit subtitle: ${card.subtitle}`)}
                >
                    {card.subtitle || 'Card subtitle goes here.'}
                </p>
                <button
                    className="preview-card-button"
                    style={{
                        color: card.btnColor,
                        borderColor: card.btnColor,
                    }}
                    onClick={interactive && onClick ? () => onClick(`card-${cardIndex + 1}-btnText`) : undefined}
                    title={interactive ? "Click to edit button text" : undefined}
                    aria-label={interactive ? `Edit button text: ${card.btnText}` : undefined}
                >
                    {card.btnText || 'BUTTON TEXT'}
                    {card.showArrow !== false && <ArrowButtonHome />}
                </button>
            </div>
        </div>
    );
});
